import { Award, BarChart2, ChevronRight, Download, FileSpreadsheet, Lock, Trophy } from 'lucide-react';

export default function ViewDashboard() {
  return (
    <div className='demo-view-enter space-y-8'>
      <div className='grid grid-cols-2 md:grid-cols-4 gap-4'>
        {[
          { v: '18', l: 'inscriptions (30j)', c: 'text-blue-600 dark:text-blue-400' },
          { v: '7', l: 'concours joués', c: 'text-emerald-600 dark:text-emerald-400' },
          { v: '3', l: 'podiums', c: 'text-amber-600 dark:text-amber-400' },
          { v: '2', l: 'exports', c: 'text-purple-600 dark:text-purple-400' },
        ].map(({ v, l, c }) => (
          <div
            key={l}
            className='bg-slate-50 border border-slate-200 dark:bg-slate-900 dark:border-slate-800 rounded-2xl p-5 text-center'
          >
            <p className={`text-2xl font-black ${c}`}>{v}</p>
            <p className='text-[11px] text-slate-500 mt-1'>{l}</p>
          </div>
        ))}
      </div>

      <div className='grid md:grid-cols-2 gap-6'>
        {/* Exports */}
        <div>
          <p className='text-[10px] font-black text-slate-500 uppercase tracking-widest mb-4'>Exports</p>
          <div className='space-y-3'>
            {[
              { icon: Download, title: 'Liste des membres (CSV)', desc: 'Pour licence, assurance, admin.' },
              { icon: FileSpreadsheet, title: 'Inscriptions concours (CSV)', desc: 'Équipes + statuts + paiements.' },
              { icon: BarChart2, title: 'Classements concours (CSV)', desc: 'Résultats, rangs, podiums.' },
            ].map(({ icon: Icon, title, desc }) => (
              <div
                key={title}
                className='bg-white border border-slate-200 dark:bg-slate-900/60 dark:border-slate-800 rounded-2xl p-4 flex items-center gap-3'
              >
                <div className='w-10 h-10 bg-slate-100 border border-slate-200 dark:bg-slate-800 dark:border-slate-700 rounded-2xl flex items-center justify-center shrink-0'>
                  <Icon className='w-4 h-4 text-slate-500 dark:text-slate-400' />
                </div>
                <div className='flex-1 min-w-0'>
                  <p className='font-bold text-slate-900 dark:text-white text-sm truncate'>{title}</p>
                  <p className='text-xs text-slate-500 dark:text-slate-400 mt-0.5'>{desc}</p>
                </div>
                <ChevronRight className='w-5 h-5 text-slate-400 dark:text-slate-600' />
              </div>
            ))}
          </div>
        </div>

        {/* Club Pro teaser */}
        <div>
          <p className='text-[10px] font-black text-slate-500 uppercase tracking-widest mb-4'>
            Fonctionnalités avancées
          </p>

          <div className='space-y-2 mb-4'>
            {[
              { icon: Trophy, text: 'Historique complet du club (saisons)' },
              { icon: Award, text: 'Analytics club (top joueurs, partenaires)' },
              { icon: BarChart2, text: 'Stats par format (doublette/triplette) & joueurs' },
              { icon: Download, text: 'Export CSV classements concours' },
              { icon: FileSpreadsheet, text: 'Exports avancés (compta, justificatifs)' },
            ].map(({ icon: Icon, text }) => (
              <div
                key={text}
                className='bg-slate-50 border border-slate-200 dark:bg-slate-900/60 dark:border-slate-800 rounded-xl p-3 flex items-center gap-3'
              >
                <div className='w-7 h-7 bg-slate-200 border border-slate-300 dark:bg-slate-800 dark:border-slate-700 rounded-lg flex items-center justify-center shrink-0'>
                  <Icon className='w-3.5 h-3.5 text-slate-400 dark:text-slate-600' />
                </div>
                <span className='text-slate-500 dark:text-slate-600 text-xs flex-1'>{text}</span>
                <Lock className='w-3.5 h-3.5 text-slate-400 dark:text-slate-700 shrink-0' />
              </div>
            ))}
          </div>

          <div className='bg-gradient-to-r from-blue-600/20 to-indigo-600/20 border border-blue-500/25 rounded-2xl p-4 flex items-center justify-between'>
            <div>
              <p className='font-bold text-slate-900 dark:text-white text-sm'>Club Pro</p>
              <p className='text-xs text-blue-600 dark:text-blue-300 mt-0.5'>Sans pub · admins multiples</p>
            </div>
            <div className='text-right'>
              <p className='font-black text-slate-900 dark:text-white text-lg'>
                20 €<span className='text-xs font-normal text-blue-600 dark:text-blue-300'>/mois</span>
              </p>
            </div>
          </div>

          <p className='mt-3 text-[10px] text-slate-500 dark:text-slate-700 leading-relaxed'>
            Club Free inclut les bases. Club Pro débloque les exports avancés et les analytics.
          </p>
        </div>
      </div>
    </div>
  );
}
